
import Vue from 'vue';
import { TextModel } from '@descomplica/dex-models';
import TextContent from '../contents/TextContent.vue';

export default Vue.extend({
  components: {
    TextContent,
  },
  props: {
    content: {
      type: TextModel,
      required: true,
    },
    trustedContent: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.updateContentLinks();
  },
  methods: {
    updateContentLinks() {
      const queryArticleLinks = this.$el.querySelectorAll('.article-text a');
      queryArticleLinks.forEach((qal) => {
        if (!qal.hasAttribute('target')) {
          qal.setAttribute('target', '_blank');
        }
      });
    },
  },
});
